import { Component } from '@angular/core';
import { config } from '../../../config';


@Component({
    selector: 'my-app-footer',
    styles: [],
    template: require('./footer.component.html')
})
export class AppFooterComponent {
    AppConfig: string;
    constructor() {}

    ngOnInit() {
        this.AppConfig = config.ReleaseVersionNo;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/footer/footer.component.ts